import { useState, useEffect, useContext } from 'react';
import styles from './index.module.scss'
import { Collapse, message, Popover } from 'antd';
import FillLightBar from './fillLightBar'
import MagicEraseBar from './magicEraseBar'
import HandRepairBar from './handRepairBar'
import Iconfont from '@utils/Iconfont';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { AIEditContext } from '../AIEditContext';

const BASE_URL = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/batchProduceImages/'

const EditLeftBar = (props) => {
    const {  setOperateType, setPaintSize,  setEraserSize, setModeState, AIEditLoading} = useContext(AIEditContext)
    const { url, handleDraw, repairSizeChange, createClick,
    } = props
    const panelStyle = {
        marginBottom: 10,
        background: '#fff',
        borderRadius: '5px',
        border: 'none',
        with: '340px'
    }

    const mattingBox = (
        <div className={styles.mattingBox}>
            <div
                onClick={() => window.open(url ? `/home/image_extraction?url=${encodeURIComponent(url)}` : `/home/image_extraction`, '_blank')}
                className={styles.mattingBoxItem}>
                <span><Iconfont type="icon-mattingOutlined" className={styles.Icon} />智能抠图</span>
                <Iconfont type="icon-newpageOutlined" className={styles.Icon2} />
            </div>
            <div
                onClick={() => window.open(url ? `/home/imageResize?url=${encodeURIComponent(url)}` : `/home/imageResize`, '_blank')}
                className={styles.mattingBoxItem}>
                <span><Iconfont type="icon-picResizeOutlined" className={styles.Icon} />高清改尺寸</span>
                <Iconfont type="icon-newpageOutlined" className={styles.Icon2} />
            </div>
        </div>
    )

    const ContentBox = (
        <div style={{ display: 'flex', gap: 12 }}>
            <div style={{ width: 180 }}>
                <img style={{ width: '100%', borderRadius: 8, display: 'block' }} src={BASE_URL + '1.png'} alt="标准模式" />
                <div style={{ marginTop: 8, fontWeight: 500 }}>标准模式</div>
                <div style={{ fontSize: 12, color: '#667085' }}>使人物与环境的光影和谐一致</div>
            </div>
            <div style={{ width: 180 }}>
                <img style={{ width: '100%', borderRadius: 8, display: 'block' }} src={BASE_URL + '2.png'} alt="人像模式" />
                <div style={{ marginTop: 8, fontWeight: 500 }}>人像模式</div>
                <div style={{ fontSize: 12, color: '#667085' }}>使人脸与身体的光影和谐一致</div>
            </div>
            <div style={{ width: 180 }}>
                <img style={{ width: '100%', borderRadius: 8, display: 'block' }} src={BASE_URL + '3.png'} alt="反光板模式" />
                <div style={{ marginTop: 8, fontWeight: 500 }}>反光板模式</div>
                <div style={{ fontSize: 12, color: '#667085' }}>使人脸光影更柔和，降低对比度</div>
            </div>
        </div>
    )

    const getItems = (panelStyle) => [
        {
            key: 'filllight',
            label: <p className={styles.title} style={{ display: 'flex', alignItems: 'center' }}><Iconfont type="icon-lightIconOutlined" className={styles.Icon} /> 智能补光
                <Popover content={ContentBox} placement="right">
                    <QuestionCircleOutlined style={{ marginLeft: 8, cursor: 'pointer' }} />
                </Popover>
            </p>,
            children: <FillLightBar saveResult={props.saveResult} isFilter={false} url={url}  createClick={createClick} />,
            style: panelStyle,
        }, {
            key: 'magicErase',
            label: <p className={`${styles.title}`}><Iconfont type="icon-magicIconOutlined" className={styles.Icon} />魔法擦除</p>,
            children: <MagicEraseBar url={url} handleDraw={handleDraw} repairSizeChange={repairSizeChange} createClick={createClick} />,
            style: panelStyle,
        }, {
            key: 'handRepair',
            label: <p className={`${styles.title}`}><Iconfont type="icon-handRepairOutlined" className={styles.Icon} />手部修复</p>,
            children: <HandRepairBar url={url} handleDraw={handleDraw} repairSizeChange={repairSizeChange} createClick={createClick} />,
            style: panelStyle,
        },
    ]

    const [activeKey, setActiveKey] = useState([props.activeKey])
    useEffect(() => {
        setOperateType('draw')
        setPaintSize(20)
        setEraserSize(20)
        setModeState('paint')
        setActiveKey([props.activeKey])
    }, [props.activeKey])

    const collapseChange = (val) => {
        if(AIEditLoading) {
            message.warning('请等待应用生效后操作！')
            return
        }
        if (val.length == 0) return
        setActiveKey(val)
        props.onClick({ key: val[0] })
        props.setOutputMask()
    }

    return (
        <div className={styles.editLeftBar}>
            {mattingBox}
            <Collapse
                accordion={true}
                bordered={false}
                activeKey={activeKey}
                expandIconPosition="end"
                expandIcon={({ isActive }) => <img className={isActive ? styles.rotate_sty : null} src={require('@assets/images/collapseIcon.png')} />}
                style={{
                    background: '#fff',
                }}
                items={getItems(panelStyle)}
                onChange={collapseChange}
            />
        </div>
    )

}

export default EditLeftBar